import { Decodable } from './_decodable';

class Notification extends Decodable {
    id: number
    notifiableId: number
    notifiableType: string
    notifiableTitle: string
    notifiableLink?: string
    notifiable: any
    message: string
    timeElapsed: string

    readAt: Date
    createdAt: Date
    updatedAt: Date

    protected _map = {
        readAt: e => this.parseDate(e),
        createdAt: e => this.parseDate(e),
        updatedAt: e => this.parseDate(e),
    }
}

export {
    Notification
}